import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    try {
      await fetch("/", {
        method: "POST",
        body: data,
      });
      setSubmitted(true);
      setError(false);
      form.reset();
    } catch (err) {
      setError(true);
    }
  };

  if (submitted) {
    return (
      <div className="contact-form-success">
        Thank you for your message! I'll be in touch soon, maybe late? Who
        knows!
      </div>
    );
  }

  return (
    <form
      className="contact-form"
      name="contact"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
    >
      <h2 className="contact-form-header">🪶 Contact Me</h2>
      <input type="hidden" name="form-name" value="contact" />
      <p hidden>
        <label>
          Don’t fill this out: <input name="bot-field" />
        </label>
      </p>
      <div className="form-group">
        <input
          className="form-control"
          id="name"
          type="text"
          placeholder="Name"
          name="name"
          required
        />
      </div>
      <div className="form-group">
        <input
          className="form-control"
          type="email"
          placeholder="Email Address"
          name="email"
          required
        />
      </div>
      <div className="form-group">
        <textarea
          className="form-control"
          id="message"
          type="text"
          placeholder="Message"
          name="message"
          rows={4}
          required
        ></textarea>
      </div>
      <button className="btn btn-primary btn-lg bg-dark mt-2" type="submit">
        Submit
      </button>
      {error && (
        <div className="contact-form-error">
          Sorry, there was a problem submitting your form. Please try again.
        </div>
      )}
    </form>
  );
};

export default ContactForm;
